import { render, staticRenderFns } from "./DoseAdhesionPanel.vue?vue&type=template&id=2d13f3f8&"
import script from "./DoseAdhesionPanel.vue?vue&type=script&lang=js&"
export * from "./DoseAdhesionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports